module.exports = __webpack_public_path__ + "img/api_relocate_dark.4d882f67.png";